import routePermissions from "../middlewares/permissions_control/routePermissions";
import {
	hasPermission,
	setPermissions
} from "../middlewares/permissions_control/permissions";
import redirectRoute from "../middlewares/permissions_control/redirectRoute";

export default {
	install(Vue, Router) {
		Vue.prototype.$permissions = {
			set: function set(permissions) {
				setPermissions(permissions);
			},

			can: hasPermission,
			redirectRoute
		};

		routePermissions(Router, hasPermission);
	}
};
